import React from "react";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";

import HeroSection from "./Components/HeroSection";

import PricePerToken from "./Components/PricePerToken";
import MultiCrypto from "./Components/MultiCrypto";
import TokenStart from "./Components/TokenStart";

import DocumentSection from "./Components/DocumentSection";
import Roadmap from "./Components/Roadmap";
import Team from "./Components/Team";
import  PreSale  from "./Components/PreSale";
import { Membership } from "./Components/Membership";
import { Whyjoin } from "./Components/Whyjoin";
import { Advisors } from "./Components/Advisors";
import AboutSection from "./Components/AboutSection";
import OurPartners from "./OurPartners";

export default function () {
  return (
    <>
      <Header />
      <div className="mx-auto">
        <HeroSection />
        <AboutSection/>
        <PricePerToken />
       
       
     
        <MultiCrypto />
        <TokenStart />
      
        <Membership />
        <Whyjoin />
        <DocumentSection />
        <Roadmap />
        <OurPartners/>
        <Team />
        <Advisors/>
      </div>
      <Footer />
    </>
  );
}
